import PageTemplate from '../components/PageTemplate';
import AboutContent from '../components/AboutContent'

const About = () => (
    <PageTemplate element={<AboutContent/>} page={"about"} />
);

export default About;